export const useHomePageStore = createPageStore('homepage')
